var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderwaterJelly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "143px",
    viewBox: "0 0 106 143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Jelly Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,8.87182689 L15,31.3044021 C15,35.4465377 11.6421356,38.8044021 7.5,38.8044021 C3.35786438,38.8044021 5.07265313e-16,35.4465377 0,31.3044021 L0,4.65516162 C1.4303964,2.16015234 3.06443816,4.89173037e-13 6.01037519,4.8316906e-13 C10.6191185,4.73776196e-13 12.3462643,5.28691702 15,8.87182689 Z M44.280112,10.4668269 L44.280112,45.4845938 C44.280112,50.1875228 40.4676348,54 35.7647059,54 C31.0617769,54 27.2492997,50.1875228 27.2492997,45.4845938 L27.2492997,5.7954643 C28.8528627,2.85751859 30.5056985,4.8316906e-13 33.8939513,4.8316906e-13 C39.2581949,4.8316906e-13 40.7186591,7.16233198 44.280112,10.4668269 Z M71.5294118,9.81635177 L71.5294118,35.164758 C71.5294118,39.3973941 68.0981823,42.8286236 63.8655462,42.8286236 C59.6329102,42.8286236 56.2016807,39.3973941 56.2016807,35.164758 L56.2016807,3.92146979 C57.5360404,1.75130485 59.1249861,4.8316906e-13 61.7775273,4.8316906e-13 C66.8120684,4.8316906e-13 68.4079588,6.3089522 71.5294118,9.81635177 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3277311,16.168167 C13.9682595,14.5863649 12.3590178,13.4125691 10.0315923,13.4125691 C4.50502573,13.4125691 3.49056042,20.0309503 7.77156117e-16,23.0147759 L0,-5.15135185 C1.25800842e-15,-9.38398791 3.43122948,-12.8152174 7.66386555,-12.8152174 C11.8965016,-12.8152174 15.3277311,-9.38398791 15.3277311,-5.15135185 L15.3277311,16.168167 Z M44.280112,16.6788343 C42.830185,14.8456944 41.1353313,13.4125691 38.5636236,13.4125691 C32.4150051,13.4125691 31.8513859,21.6046845 27.2492997,23.8695652 L27.2492997,11.6682823 C27.2492997,6.96535338 31.0617769,3.15287618 35.7647059,3.15287618 C40.4676348,3.15287618 44.280112,6.96535338 44.280112,11.6682823 L44.280112,16.6788343 Z M71.5294118,15.2620078 C70.3496376,14.1583151 68.9507877,13.4125691 67.0956549,13.4125691 C61.1393885,13.4125691 60.4241474,21.1001412 56.2016807,23.6400329 L56.2016807,-1.60288661 C56.2016807,-5.83552267 59.6329102,-9.26675215 63.8655462,-9.26675215 C68.0981823,-9.26675215 71.5294118,-5.83552267 71.5294118,-1.60288661 L71.5294118,15.2620078 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.046959,79.6540476 C98.0925006,82.6091034 96.607601,86.25 92.6339616,86.25 C85.9464237,86.25 85.5848384,75.9375 78.8937205,75.9375 C72.2026026,75.9375 72.5641879,86.25 65.87665,86.25 C59.1891121,86.25 58.8275268,75.9375 52.1364088,75.9375 C45.4452909,75.9375 45.8068762,86.25 39.1193383,86.25 C32.4318004,86.25 32.0702151,75.9375 25.3790972,75.9375 C18.6879792,75.9375 19.0495645,86.25 12.3620266,86.25 C10.2602699,86.25 8.78333809,85.2314172 7.53838058,83.8344912 C2.75303157,75.5062047 0,65.746755 0,55.3125 C0,24.7642498 23.5972273,0 52.7058824,0 C81.8145374,0 105.411765,24.7642498 105.411765,55.3125 C105.411765,64.0471157 103.482571,72.3088597 100.046959,79.6540476 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DC5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98E4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 26,
    y: 102,
    width: 46,
    height: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset-3",
    transform: "translate(-171.000000, -106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jelly-Copy",
    transform: "translate(160.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.341076,104.654048 C109.386618,107.609103 107.901719,111.25 103.928079,111.25 C97.2405414,111.25 96.8789561,100.9375 90.1878382,100.9375 C83.4967202,100.9375 83.8583055,111.25 77.1707676,111.25 C70.4832297,111.25 70.1216444,100.9375 63.4305265,100.9375 C56.7394086,100.9375 57.1009938,111.25 50.4134559,111.25 C43.725918,111.25 43.3643327,100.9375 36.6732148,100.9375 C29.9820969,100.9375 30.3436822,111.25 23.6561443,111.25 C21.5543876,111.25 20.0774557,110.231417 18.8324982,108.834491 C14.0471492,100.506205 11.2941176,90.746755 11.2941176,80.3125 C11.2941176,49.7642498 34.891345,25 64,25 C93.108655,25 116.705882,49.7642498 116.705882,80.3125 C116.705882,89.0471157 114.776688,97.3088597 111.341076,104.654048 Z",
    id: "Body-Copy-2",
    fill: "#FB70A9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Legs",
    transform: "translate(30.117647, 88.750000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#4E56A6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fillOpacity: 0.298513986,
    fill: "#000000",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.341076,104.654048 C109.386618,107.609103 107.901719,111.25 103.928079,111.25 C97.2405414,111.25 96.8789561,100.9375 90.1878382,100.9375 C83.4967202,100.9375 83.8583055,111.25 77.1707676,111.25 C70.4832297,111.25 70.1216444,100.9375 63.4305265,100.9375 C56.7394086,100.9375 57.1009938,111.25 50.4134559,111.25 C43.725918,111.25 43.3643327,100.9375 36.6732148,100.9375 C29.9820969,100.9375 30.3436822,111.25 23.6561443,111.25 C21.5543876,111.25 20.0774557,110.231417 18.8324982,108.834491 C14.0471492,100.506205 11.2941176,90.746755 11.2941176,80.3125 C11.2941176,49.7642498 34.891345,25 64,25 C93.108655,25 116.705882,49.7642498 116.705882,80.3125 C116.705882,89.0471157 114.776688,97.3088597 111.341076,104.654048 Z",
    id: "Body-Copy-4",
    fill: "#FB70A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89013,110.339908 C114.280106,90.309894 114.247756,68.0737125 101.79308,43.6313635 C110.988899,53.250262 116.705882,66.7321902 116.705882,81.6576087 C116.705882,90.0124584 114.914488,97.9149962 111.724277,104.940828 C109.909423,107.767403 108.530587,111.25 104.84078,111.25 C103.676583,111.25 102.718845,110.903305 101.89013,110.339908 Z",
    id: "Combined-Shape",
    fill: "#E24CA6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "goggles",
    transform: "translate(11.294118, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body-Copy-5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#088FDA",
    strokeWidth: 1.75,
    fill: "#00B3FF",
    mask: "url(#mask-6)",
    x: -12.6779412,
    y: 38.375,
    width: 124.744118,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes-Copy-2",
    transform: "translate(0.000000, 32.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3589744,69.2211538 C39.8537171,69.2211538 28.2295626,57.0818979 28.2295626,36.4856167 C28.2295626,16.9413776 43.8404357,-0.278846154 62.3589744,-0.278846154 C80.877513,-0.278846154 96.4883861,16.9413776 96.4883861,36.4856167 C96.4883861,57.0818979 84.8642317,69.2211538 62.3589744,69.2211538 Z",
    id: "Oval",
    stroke: "#0097EB",
    strokeWidth: 2,
    fill: "#31C2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "EyeBall",
    transform: "translate(36.102564, 7.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2564103,53.9423077 C44.7331434,53.9423077 52.5128205,43.4630809 52.5128205,28.5810023 C52.5128205,13.6989238 40.7574252,-4.97379915e-14 26.2564103,-4.97379915e-14 C11.7553953,-4.97379915e-14 2.13162821e-14,13.6989238 2.13162821e-14,28.5810023 C2.13162821e-14,43.4630809 7.77967711,53.9423077 26.2564103,53.9423077 Z",
    id: "Oval-Copy-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pupil",
    transform: "translate(9.350750, 8.173077)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#030776",
    cx: 9.84615385,
    cy: 10.625,
    rx: 9.84615385,
    ry: 10.625
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 8.20512821,
    cy: 8.17307692,
    rx: 4.92307692,
    ry: 4.90384615
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62.3589744,61.4423077 C80.8357075,61.4423077 88.6153846,50.9630809 88.6153846,36.0810023 C88.6153846,21.1989238 76.8599893,7.5 62.3589744,7.5 C47.8579594,7.5 36.1025641,21.1989238 36.1025641,36.0810023 C36.1025641,50.9630809 43.8822412,61.4423077 62.3589744,61.4423077 Z",
    id: "Oval-Copy-10",
    fill: "url(#linearGradient-7)",
    opacity: 0.389625186
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0235294,37.5 L80.5936652,26.9711538",
    id: "Path-2",
    stroke: "#FFF7F7",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5058824,50.25 L83.5764706,32.25",
    id: "Path-2-Copy",
    stroke: "#FFF7F7",
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30,116 C33.3333333,117.333333 38.3333333,117.666667 45,117 L45,113 L30,112 L30,116 Z",
    id: "Path-7",
    fill: "#363C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8784314,9.16460054 C32.8784314,9.16460054 32.8784314,9.16460054 32.8784314,9.16460054 C32.8784314,7.95294921 32.2030906,6.84232153 31.1273176,6.28481687 L20.4283884,0.740242802 C19.9380386,0.4861257 19.3345289,0.677630154 19.0804118,1.16797997 C19.0097767,1.30427894 18.9714704,1.45501055 18.9684609,1.60849561 L18.8235294,9 C28.1934641,27.6201643 32.8784314,27.6750312 32.8784314,9.16460054 Z",
    id: "Path-5-Copy",
    fill: "#0097EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0328219,102.270669 C34.4938911,101.931703 32.1284314,99.2466522 32.1284314,94.4615385 L32.1284314,9.93211594 L19.5735294,9.76033216 L19.5735294,101.557692 C19.5735294,110.527789 26.2168979,115 39.9058824,115 C52.8772692,115 59.5223626,110.98438 60.1834091,102.931294 C59.4083242,103.621821 58.6756892,104.667564 57.5599013,106.485995 C57.5592989,106.486977 57.5592989,106.486977 57.5586965,106.487958 C55.0564922,110.565871 53.5562471,112 50.4134559,112 C47.2876244,112 45.7050069,110.582216 42.9270533,106.519246 C42.9263053,106.518152 42.9263053,106.518152 42.9255574,106.517058 C41.1869225,103.974172 40.3121603,102.950606 39.0328219,102.270669 Z",
    id: "Combined-Shape",
    stroke: "#0097EB",
    strokeWidth: 1.5,
    fill: "#00B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,9 L27,81.5147186 C27,86.947753 29.1582645,92.1582645 33,96 L33,96 L33,9 L27,9 Z",
    id: "Path-6",
    fill: "#0097EB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(49.000000, 112.500000) scale(1, -1) translate(-49.000000, -112.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1529748,99.5647838 C64.3128763,101.600334 64.1018134,102.9375 63.4305265,102.9375 C56.7394086,102.9375 57.1009938,113.25 50.4134559,113.25 C43.725918,113.25 41,102 38,102 C37.4957612,102 37.2384066,101.620053 37.192809,100.958905 C37.0239113,100.944763 36.8507921,100.9375 36.6732148,100.9375 C32.7925167,100.9375 44.6477933,77 54,77 C59.787493,77 64.6221899,94.4786895 64.1529748,99.5647838 Z M64.1529748,99.5647838 C63.6434303,93.0782691 59.366923,79.5 54.2117647,79.5 C46.074861,79.5 36.8875161,96.5322754 37.192809,100.958905 C43.3879807,101.477609 43.9034003,111.25 50.4134559,111.25 C57.1009938,111.25 56.7394086,100.9375 63.4305265,100.9375 C63.8394261,100.9375 64.0730829,100.430778 64.1529748,99.5647838 Z",
    id: "Combined-Shape",
    fill: "#007ABE",
    mask: "url(#mask-9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwaterJelly);
export default __webpack_public_path__ + "static/media/underwater_jelly.693994a0f81996b9a2dce04da930616c.svg";
export { ForwardRef as ReactComponent };